import { faMicrosoft } from "@fortawesome/free-brands-svg-icons";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { LelyIconBase, type LelyIconBaseProps } from "@/components/ui/Icons/LelyIconBase";

/* --- COMMON --- */
export { LelyIconBase, type LelyIconBaseProps };
export { SvgIconBase, type SvgIconBaseProps } from "@/components/ui/Icons/SvgIconBase";

/* --- CUSTOM ICONS --- */
export { MilkingAttachmentIcon } from "@/components/ui/Icons/custom-icons/MilkingAttachmentIcon";
export { MilkingEndMilkingIcon } from "@/components/ui/Icons/custom-icons/MilkingEndMilkingIcon";
export { MilkingPeakMilkingIcon } from "@/components/ui/Icons/custom-icons/MilkingPeakMilkingIcon";
export { MilkingPostTreatmentIcon } from "@/components/ui/Icons/custom-icons/MilkingPostTreatmentIcon";
export { MilkingPreTreatmentIcon } from "@/components/ui/Icons/custom-icons/MilkingPreTreatmentIcon";
export { MilkingStartMilkingIcon } from "@/components/ui/Icons/custom-icons/MilkingStartMilkingIcon";
export { MilkingVisitBehaviorIcon } from "@/components/ui/Icons/custom-icons/MilkingVisitBehaviorIcon";

/* --- FONTAWESOME ICONS --- */
export const CloseIcon = () => <FontAwesomeIcon icon="times" />;
export const CheckIcon = () => <FontAwesomeIcon icon="check" />;
export const ErrorIcon = () => <FontAwesomeIcon icon="exclamation-triangle" />;
export const ChameleonSolutionIcon = () => <FontAwesomeIcon icon="clipboard-check" />;
export const ChameleonContextIcon = () => <FontAwesomeIcon icon="info-circle" />;
export const ChameleonProblemIcon = () => <FontAwesomeIcon icon="exclamation-triangle" />;
export const HintIcon = () => <FontAwesomeIcon icon="lightbulb" />;
export const AgreeIcon = () => <FontAwesomeIcon icon="check" />;
export const DisagreeIcon = () => <FontAwesomeIcon icon="times" />;
export const UndoIcon = () => <FontAwesomeIcon icon="undo" />;
export const SaveIcon = () => <FontAwesomeIcon icon="save" />;
export const MinusCircleIcon = () => <FontAwesomeIcon icon="minus-circle" />;
export const XMarkIcon = () => <FontAwesomeIcon icon={faXmark} />;
export const SubmitIcon = () => <FontAwesomeIcon icon="paper-plane" />;
export const ChevronDownIcon = () => <FontAwesomeIcon icon="chevron-down" />;
export const ChevronRightIcon = () => <FontAwesomeIcon icon="chevron-right" />;
export const TrendIncreaseIcon = () => <FontAwesomeIcon icon="arrow-up" />;
export const TrendDecreaseIcon = () => <FontAwesomeIcon icon="arrow-down" />;
export const TrendStableIcon = () => <FontAwesomeIcon icon="minus" />;
export const LinkIcon = () => <FontAwesomeIcon icon="external-link-alt" />;
export const MicrosoftIcon = () => <FontAwesomeIcon icon={faMicrosoft} />;

/* --- LELY ICONS --- */
export const InfoIcon = () => <LelyIconBase icon="info" />;
export const CowIcon = () => <LelyIconBase icon="cow" />;
export const AstronautIcon = () => <LelyIconBase icon="astronaut" />;
export const FarmIcon = () => <LelyIconBase icon="farm" />;
export const HerdIcon = () => <LelyIconBase icon="herd" />;
export const GraphIcon = () => <LelyIconBase icon="graph" />;
